import { FC } from "react";
import {
  RedCard,
  TitleSkeleton,
  PurpleCard,
  DescriptionSkeleton,
  OrangeCard,
  GridContainer,
} from "../../../styled";

const GridCarouselColoredPromotions: FC = () => {
  return (
    <GridContainer>
      <PurpleCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </PurpleCard>
      <RedCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </RedCard>
      <OrangeCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </OrangeCard>
      <PurpleCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </PurpleCard>
      <RedCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </RedCard>
      <PurpleCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </PurpleCard>
      <OrangeCard>
        <TitleSkeleton />
        <DescriptionSkeleton />
      </OrangeCard>
    </GridContainer>
  );
};

export default GridCarouselColoredPromotions;
